<script setup lang="ts">
definePageMeta({
  title: 'pages.accessibility.seo.title',
});
</script>

<template>
  <div>
    <LegalAccessibility />
  </div>
</template>
